import PubSub from "underpub-js";

var ListingTeamMembers = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ListingTeamMembers',
	};

	$.extend(true, this.options, options);

};

ListingTeamMembers.prototype.init = function() {

	var self = this;

};

export default ListingTeamMembers;
